import { ChangedFieldsRow } from "./ChangedFieldsRow";
import { Column, InfoBox } from "@/components";

import { jobStatusToLabel } from "@/lib/constants";
import { JobStatus } from "@/types";

export const ActiveStatusSection = ({
  originalStatus,
}: {
  originalStatus?: JobStatus;
}) => {
  return (
    <Column className="gap-3">
      <InfoBox variant="warning">
        This will move this job into the Active status, allowing users on the
        talent platform to apply.
      </InfoBox>
      {originalStatus && (
        <ChangedFieldsRow
          label="Status"
          oldValue={jobStatusToLabel[originalStatus]}
          newValue={jobStatusToLabel[JobStatus.ACTIVE]}
        />
      )}
    </Column>
  );
};
